import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import PhoneInput from '@/_components/input/phone/phone.vue'

import AutocompleteProject from '@/components/Autocomplete/Project/Project.vue'
import AutocompleteUser from '@/components/Autocomplete/User/User.vue'
import AutocompleteCompany from '@/components/Autocomplete/company.vue'
import Dialog from '@/components/Dialog/Dialog.vue'
import Container from '@/components/Placeholders/Container/Container.vue'
import RichTextField from '@/components/RichTextField/richTextField.vue'

import CurrencyAutocomplete from '@/components/Autocomplete/currency.vue'
import ProjectModel from '@/views/Project/Project/models/project'
import ProjectGroupModel from '@/views/Project/Project/models/projectGroup'
import InvoiceRecipientCombobox from '../Components/invoiceRecipient.vue'

@Component({
    components: {
        ToolbarComponent,
        PhoneInput,
        AutocompleteProject,
        AutocompleteUser,
        AutocompleteCompany,
        Dialog,
        Container,
        CurrencyAutocomplete,
        RichTextField,
        InvoiceRecipientCombobox,
    },
    mixins: [ProjectMixin],
})
export default class GeneralSettings extends Mixins<MixinInterface>(ProjectMixin) {
    loading = false

    showLog() {
        this.type == 'project'
            ? ProjectModel.showLog(this.projectBase)
            : ProjectGroupModel.showLog(this.groupBase)
    }

    get sessionUserId() {
        return this.currentUser.id
    }

    get type() {
        return this.$route.params.type == 'p' ? 'project' : 'group'
    }

    get isAccessible() {
        return true
        // let res = false
        // Object.values(
        //     this.projectBase
        //         ? this.projectBase.attributes.constraints
        //         : this.groupBase.attributes.constraints
        // ).map((constraint: any) => {
        //     constraint.writable ? (res = true) : ''
        // })
        // return res
    }

    // PROJECT
    project: any = null
    loadingUpdate = false
    valid = false

    get projectBase() {
        return this.type == 'project' ? this.$store.getters.project(this.$route.params.id) : null
    }

    get stagedChangesProject() {
        if (this.project) {
            this.project.attributes.customId ? null : (this.project.attributes.customId = null)
            this.project.attributes.bklrId ? null : (this.project.attributes.bklrId = null)
        }

        let diff = this.difference(this.project, this.projectBase)

        diff?.attributes?.hasOwnProperty('customId') && !diff.attributes.customId
            ? (this.project.attributes.customId = null)
            : null
        let result = {
            ...(diff.attributes && {
                attributes: {
                    ...(diff.attributes.hasOwnProperty('customId') && {
                        customId: diff.attributes.customId ? diff.attributes.customId : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('bklrId') && {
                        bklrId: diff.attributes.bklrId ? diff.attributes.bklrId : null,
                    }),
                    ...(diff.attributes.name && { name: diff.attributes.name }),
                    ...(diff.attributes.hasOwnProperty('description') &&
                        !this.isEqualRichText(
                            this.project.attributes.description,
                            this.projectBase.attributes.description
                        ) && { description: diff.attributes.description }),
                    ...(diff.attributes.hasOwnProperty('avatarFileId') && {
                        avatarFileId: diff.attributes.avatarFileId,
                    }),
                    ...(diff.attributes.timeZone && { timeZone: diff.attributes.timeZone }),
                    ...(diff.attributes.hasOwnProperty('currency') && {
                        currency: diff.attributes.currency,
                    }),
                    ...(diff.attributes.hasOwnProperty('address') && {
                        address: diff.attributes.address ? diff.attributes.address : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('latitude') && {
                        latitude: diff.attributes.latitude,
                    }),
                    ...(diff.attributes.hasOwnProperty('longitude') && {
                        longitude: diff.attributes.longitude,
                    }),
                    ...(diff.attributes.hasOwnProperty('emergencyNumber') && {
                        emergencyNumber: diff.attributes.emergencyNumber
                            ? diff.attributes.emergencyNumber
                            : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('agreementUrl') && {
                        agreementUrl: diff.attributes.agreementUrl
                            ? diff.attributes.agreementUrl
                            : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('itbaseUrl') && {
                        itbaseUrl: diff.attributes.itbaseUrl ? diff.attributes.itbaseUrl : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('avatarFileId') && {
                        avatarFileId: diff.attributes.avatarFileId
                            ? diff.attributes.avatarFileId
                            : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('customerReference') && {
                        customerReference: diff.attributes.customerReference
                            ? diff.attributes.customerReference
                            : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('orderReference') && {
                        orderReference: diff.attributes.orderReference
                            ? diff.attributes.orderReference
                            : null,
                    }),
                    ...(diff.attributes.hasOwnProperty('invoiceRecipient') && {
                        invoiceRecipient: diff.attributes.invoiceRecipient
                            ? diff.attributes.invoiceRecipient
                            : null,
                    }),
                },
            }),
        }

        return this.isObjectEmpty(result.attributes) ? {} : result
    }

    get hasStagedChangesProject() {
        return !this.isObjectEmpty(this.stagedChangesProject)
    }

    async getProjectData() {
        this.loading = true
        await this.getProject(this.$route.params.id, true).catch(() => {
            //
        })
        this.initializeProject()
        this.loading = false
    }

    initializeProject() {
        this.project = JSON.parse(JSON.stringify(this.projectBase))
        this.descriptionId = Date.now()
    }

    async updateProject() {
        this.loadingUpdate = true
        let params = {
            updatedAt: this.$store.getters.project(this.$route.params.id).attributes.updatedAt,
            data: {
                type: 'project',
                id: this.$route.params.id,
                ...this.stagedChangesProject,
            },
        }

        await this.handlePatchProject(params)
        this.initializeProject()

        this.loadingUpdate = false
    }

    async handlePatchProject(params: any) {
        await this.patchProject(params, true).catch(async (error: any) => {
            if (error.data.response.status === 412) {
                await this.getProject(this.$route.params.id).catch(() => {
                    //
                })

                params.updatedAt = this.$store.getters.project(
                    this.$route.params.id
                )?.attributes.updatedAt

                await this.handlePatchProject(params)
            }
        })
    }

    file: any = null

    get maxBytes() {
        return this.project.attributes.constraints.avatarFileId.maxBytes
            ? this.project.attributes.constraints.avatarFileId.maxBytes
            : ''
    }

    get allowedExtensions() {
        return this.project.attributes.constraints.avatarFileId.allowedExtensions
            ? '.' + this.project.attributes.constraints.avatarFileId.allowedExtensions.join(',.')
            : ''
    }

    // UPLOAD LOGO
    async uploadFile(fileObject: any) {
        this.file = {
            links: {
                download: URL.createObjectURL(fileObject),
            },
            attributes: {
                fileId: null,
            },
        }

        let res = await this.postFile(fileObject).catch(() => {
            this.$store.dispatch('errorSnackbar', 'Problems with uploading the file')
        })
        if (res) {
            this.project.attributes.avatarFileId = res
            this.file.attributes.fileId = res
        }
    }

    get urlRule() {
        return (value: string) =>
            !value ||
            /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
                value
            )
    }

    // EDITOR JS
    descriptionId = Date.now()
    descriptionTools = [
        'header',
        'linkTool',
        'list',
        'embed',
        'quote',
        'table',
        'delimiter',
        'Marker',
        'underline',
    ]

    setDescription(description: string) {
        this.project.attributes.description = description
    }

    // GROUP
    group: any = null

    get groupBase() {
        return this.currentGroup
    }

    // PROJECTS
    setProjects(data: any) {
        this.group.relationships.projects.data = data.map((element) => {
            return { id: element, type: 'project' }
        })
    }

    // OWNERS
    get users() {
        return Object.values(this.$store.getters.projectModuleUsers)
    }

    setOwners(data: any) {
        let hasCurrentUser = false

        this.group.relationships.owners.data = data.map((element) => {
            if (this.currentUser.id == element) {
                hasCurrentUser = true
            }
            return { id: element, type: 'user' }
        })

        if (!hasCurrentUser) {
            this.group.relationships.owners.data.push({ id: this.sessionUserId, type: 'user' })
        }
    }

    // SHARED WITH
    setSharedWith(data: any) {
        this.group.relationships.sharedWith.data = data.map((element) => {
            return { id: element, type: 'user' }
        })
    }

    // COMPANIES
    get companies() {
        return Object.values(this.$store.getters.projectCompanies)
    }

    setCompanies(data: any) {
        this.group.relationships.companies.data = data.map((element) => {
            return { id: element, type: 'company' }
        })
    }

    get stagedChangesGroup() {
        let diff = this.difference(this.group, this.groupBase)
        let result = {
            ...(diff.attributes && {
                attributes: {
                    ...(diff.attributes.name && { name: diff.attributes.name }),
                },
            }),
            ...(diff.relationships && {
                relationships: {
                    ...(diff.relationships.hasOwnProperty('projects') && {
                        projects: { data: this.group.relationships.projects.data },
                    }),
                    ...(diff.relationships.hasOwnProperty('owners') && {
                        owners: { data: this.group.relationships.owners.data },
                    }),
                    ...(diff.relationships.hasOwnProperty('companies') && {
                        companies: { data: this.group.relationships.companies.data },
                    }),
                    ...(diff.relationships.hasOwnProperty('sharedWith') && {
                        sharedWith: { data: this.group.relationships.sharedWith.data },
                    }),
                },
            }),
        }
        return result
    }

    get hasStagedChangesGroup() {
        return !this.isObjectEmpty(this.stagedChangesGroup)
    }

    async getGroupData() {
        this.loading = true
        await this.getGroup(this.$route.params.id).catch(() => {
            this.loading = false
        })

        this.initializeGroup()
        this.loading = false
    }

    initializeGroup() {
        this.group = JSON.parse(JSON.stringify(this.groupBase))
    }

    async updateGroup() {
        this.loadingUpdate = true
        let params = {
            updatedAt: this.$store.getters.group(this.$route.params.id).attributes.updatedAt,
            data: {
                type: 'projectGroup',
                id: this.$route.params.id,
                ...this.stagedChangesGroup,
            },
        }

        await this.handlePatchGroup(params)
        this.initializeGroup()

        this.loadingUpdate = false
    }

    async handlePatchGroup(params: any) {
        await this.patchGroup(params).catch(async (error: any) => {
            if (error.data.response.status === 412) {
                await this.getGroup(this.$route.params.id).catch(() => {
                    //
                })

                params.updatedAt = this.$store.getters.group(
                    this.$route.params.id
                )?.attributes.updatedAt

                await this.handlePatchGroup(params)
            }
        })
        await this.getGroup(this.$route.params.id).catch(() => {
            //
        })
    }

    // DELETE GROUP
    deleteDialog = false
    deleteLoading = false

    async handleDeleteGroup() {
        this.deleteLoading = true
        let params = {
            id: this.groupBase.id,
            updatedAt: this.groupBase.attributes.updatedAt,
        }

        await this.deleteGroup(params).catch(() => {
            //
        })
        this.$router.push({ name: 'user' })
        this.deleteLoading = false
        this.deleteDialog = false
    }

    // STATES
    async created() {
        if (this.type == 'project') {
            await this.getProjectData()
        } else {
            await this.getGroupData()
        }
    }

    // LEAVING GUARD
    leaveDialog = false
    to: any = null

    async beforeRouteLeave(to: any, from: any, next: any) {
        if (this.hasStagedChangesProject || this.hasStagedChangesGroup) {
            if (this.to) {
                next()
            } else {
                this.to = to
                this.leaveDialog = true
            }
        } else {
            next()
        }
    }

    closeDialog() {
        this.leaveDialog = false
        this.to = null
    }

    discardChanges() {
        if (this.hasStagedChangesProject) {
            this.initializeProject()
        }
        if (this.hasStagedChangesGroup) {
            this.initializeGroup()
        }
        this.leaveDialog = false
        this.$router.push(this.to)
    }
}
